import { GET_BOOK_BY_ID } from 'modules/editor/store/constants';

export const getBookById = (bookId) => ({
  type: GET_BOOK_BY_ID,
  payload: {
    bookId,
  },
});
